import { CustomError } from 'ts-custom-error';

import { setClassName } from '@change-corgi/core/error';

export class BrowserOfflineError extends CustomError {
	constructor() {
		super('Browser is offline');
	}
}
setClassName(BrowserOfflineError, 'BrowserOfflineError');
